import React from "react";

import { PropsWithChildren } from "react";
import { Box, useTheme } from "@mui/material";

export const Footer = ({ children }: PropsWithChildren<unknown>) => {
  const theme = useTheme();

  if (!children) {
    return null;
  }

  return (
    <Box
      sx={{
        padding: "8px 24px",
        background: "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(10px)",
        color: theme.palette.text.secondary,
        textAlign: "center",
        fontSize: "0.9em",
        borderTop: "1px solid rgba(251, 78, 43, 0.1)",
        margin: "0 0 0 0", /* 移除所有边距，让左右下边贴近边缘 */
        borderRadius: "0", /* 移除圆角 */
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.05)"
      }}
    >
      {children}
    </Box>
  );
};
